
import { ChatHistoryView } from '../../connectivity/chat/ChatHistoryView';

export default function ExpertMessagesPage() {
  const expertCode = localStorage.getItem('expertCode') || '';

  return (
    <div className="h-full p-4 md:p-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">Message History</h1>
        <p className="text-slate-500">View your past client consultations.</p>
      </div>
      
      <ChatHistoryView role="expert" code={expertCode} />
    </div>
  );
}